export const Four = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22 25.25V14.75L15.5 23.25H23.5"
      stroke="#3D3D3D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 20C3 24.5087 4.79107 28.8327 7.97918 32.0208C11.1673 35.2089 15.4913 37 20 37C24.5087 37 28.8327 35.2089 32.0208 32.0208C35.2089 28.8327 37 24.5087 37 20C37 15.4913 35.2089 11.1673 32.0208 7.97918C28.8327 4.79107 24.5087 3 20 3C15.4913 3 11.1673 4.79107 7.97918 7.97918C4.79107 11.1673 3 15.4913 3 20Z"
      stroke="#F0F4F7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
